const volList = [
    {
        "duration": "Aug, 2022 - Nov, 2022",
        "position": "Student Coordinator",
        "name": "Training & Placement Cell, DYPIU",
        "desc": "Oversaw training & placement activities for the college, liaising closely with industry partners to support peer placements and organizing guest lectures from professionals.",
    },
    {
        "duration": "Nov, 2021 - Jul, 2022",
        "position": "AI & ML Lead",
        "name": "Google Developer Student Club",
        "desc": "GDSC is a Google-recognized student body at DYPIU that reports directly to Google on its activities. The club's mission is to help students collaborate globally and sharpen their development skills.",
    },
    {
        "duration": "Aug, 2020 - Present",
        "position": "Tech Team Associate",
        "name": "LASUX-V Club",
        "desc": "Legion of Awesome Students United in eXcellence — a club established by students, for students, focused on all-round student development alongside fun activities.",
    },
    {
        "duration": "Nov, 2020 - May, 2021",
        "position": "CP Team Associate",
        "name": "CodeChef DYPIU Chapter",
        "desc": "CodeChef College Chapters are the programming clubs run and maintained by the official Chapter Leaders and mentored by CodeChef. These clubs aim to make learning competitive programming accessible for students across the globe.",
    },
    {
        "duration": "Nov, 2020 - Jun, 2021",
        "position": "Admin Member",
        "name": "Journal Club",
        "desc": "A research club that regularly reviews and discusses recent papers and articles across scientific, medical, and philosophical literature.",
    }
]

export default volList;